
class CapViewVehicleList {
  constructor(config) {
    this.config = config
  }

  checkPermission(options = {}) {
    if (options === undefined) {
      return Boolean(this.config)
    }
    
    if (options.vendor) {
      return this._checkConfigField('vendor', options)
    }
    else {
      // options is empty
      return Boolean(this.config)
    }
  }

  optionsChangeViewField(fieldKey) {
    return this.config[fieldKey].options
  }

  _checkConfigField(fieldKey, options) {
    if (this.config[fieldKey]) {
      return this.config[fieldKey].includes(options[fieldKey])
    }
    else {
      return false
    }
  }
}

function key() {
  return 'view_vehicle_list'
}

function create(config) {
  return new CapViewVehicleList(config)
}

export default {
  key,
  create,
}
